import * as React from "react";
import { StyleSheet, Text, View } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  paragraph: {
    marginBottom: '7.5mm'
  }
})

const WebOrderPdfDetails = () => {
  return (
    <View>
      <Text style={styles.paragraph}>
        This licence provides access to ecCharts, which is ECMWF&apos;s interactive interface for visualising ECMWF real-time
        data (note: no raw data is accessible from this interface).
      </Text>
      <Text style={styles.paragraph}>
        Please note that access to all web products is provided on an &lsquo;as is&rsquo; basis. The product range is adjusted in
        the light of experience and in response to the evolution of the forecasting system; newly developed products are
        added, but others may be discontinued, at the discretion of ECMWF.
      </Text>
    </View>
  )
}

export default WebOrderPdfDetails;
